import { Tablist } from 'aria-components';
import { Component } from 'js-component-framework';

/**
 * Component for TabList component.
 */
export default class TabList extends Component {
  /**
   * Start the component.
   */
  constructor(config) {
    super(config);

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
  }

  /**
   * Initialize a TabList instance.
   */
  init() {
    const { tabs, panels } = this.children;
    this.tablist = new Tablist({ tabs, panels });
  }
}
